export default function ToolMessage({
  message,
  tone = "error",
}: {
  message: string;
  tone?: "error" | "empty";
}) {
  return (
    <div
      role={tone === "error" ? "alert" : undefined}
      className={
        tone === "error"
          ? "rounded-xl border border-brand-red/30 bg-brand-red/10 px-4 py-3 text-sm font-medium text-brand-red [&_a]:font-semibold [&_a]:underline"
          : "rounded-2xl border border-line bg-card px-6 py-10 text-center"
      }
      dangerouslySetInnerHTML={{ __html: message }}
    />
  );
}
